module.exports = __webpack_public_path__ + "static/img/20211012_5.33a780f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211012_5.png
// module id = eS7S
// module chunks = 0